import React from 'react';
import Tile, { TileProps } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content/tile';
import { LOOM_CONTENT_LOOK } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content-look';

interface Props {
  children?: React.ReactNode;
  data: TileProps;
}

const TileTastic = ({ data }: Props) => {
  return (
    <Tile
      image={data.image}
      title={data.title}
      subtitle={data.subtitle}
      ctaLabel={data.ctaLabel}
      ctaReference={data.ctaReference}
      ctaClassName={LOOM_CONTENT_LOOK.tileCtaClassName}
    />
  );
};

export default TileTastic;
